export default __webpack_public_path__ + "static/media/pixi-expanded.5da00786.jpeg";